<template>
    <span>{{ label }}</span>
</template>

<script>
export default {
    props: ['row'],
    data() {
        // Uppercase first letter of each word
        // Split on _
        const label = this.row.premium_status
            .toLowerCase()
            .split('_')
            .map((part) => {
                return part.charAt(0).toUpperCase() + part.slice(1)
            })
            .join(' ')

        return {
            label,
        }
    },
}
</script>
